import { render } from "./TenderDetail.vue?vue&type=template&id=e9ef03b2&scoped=true"
import script from "./TenderDetail.vue?vue&type=script&lang=js"
export * from "./TenderDetail.vue?vue&type=script&lang=js"

import "./TenderDetail.vue?vue&type=style&index=0&id=e9ef03b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9ef03b2"]])

export default __exports__